import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getOrganizationById } from '../../../services/organizations';
import LoadingSpinner from '../../../components/Common/LoadingSpinner';

const OrganizationDetail = () => {
  const { id } = useParams();
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (id && id !== 'undefined') {
      loadOrganization();
    } else {
      setError('Invalid organization ID');
      setLoading(false);
    }
  }, [id]);

  const loadOrganization = async () => {
    try {
      const data = await getOrganizationById(id);
      setOrg(data);
    } catch (err) {
      setError('Failed to load organization');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <div className="error">{error}</div>;
  if (!org) return <div>Organization not found</div>;

  return (
    <div>
      <h1>{org.name}</h1>
      <p><strong>Code:</strong> {org.org_code}</p>
      <p><strong>Status:</strong> {org.status}</p>
      <p><strong>Created:</strong> {new Date(org.createdAt).toLocaleDateString()}</p>
      <Link to="/dashboard/super-admin/organizations">Back to List</Link>
    </div>
  );
};

export default OrganizationDetail;